import AxiosConfig from '../../../config/AxiosConfig';

const useReserveDecomposition = () => {
  const reserveDecomposition = async ({ savOrder, createdBy, lines }) => {
    try {
      const response = await AxiosConfig.create('post', `/reservedecomposition/`)
        .call({ sav_order: savOrder, created_by: createdBy, lines })
        .getResponseData();
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error.message;
      throw new Error(errorMessage);
    }
  };

  return { reserveDecomposition };
};

export default useReserveDecomposition;
